// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditPlanPopup-module__font-s-10___CJlmW {
  font-size: 10px !important;
}

.EditPlanPopup-module__font-s-12___HQng8 {
  font-size: 12px !important;
}

.EditPlanPopup-module__font-s-13___uGwIz {
  font-size: 13px !important;
}

.EditPlanPopup-module__font-s-14___LrBA1 {
  font-size: 14px !important;
}

.EditPlanPopup-module__font-s-15___cx8HE {
  font-size: 15px !important;
}

.EditPlanPopup-module__font-s-16___RRA7z {
  font-size: 16px !important;
}

.EditPlanPopup-module__font-s-18___h7sCD {
  font-size: 18px !important;
}

.EditPlanPopup-module__font-s-20___gTZQs {
  font-size: 20px !important;
}

.EditPlanPopup-module__font-s-22___JSVIT {
  font-size: 22px !important;
}

.EditPlanPopup-module__font-s-28___GNCil {
  font-size: 28px !important;
}

.EditPlanPopup-module__font-w-400___PsrkX {
  font-weight: 400 !important;
}

.EditPlanPopup-module__font-w-500___b8a0x {
  font-weight: 500 !important;
}

.EditPlanPopup-module__font-w-600___blWhw {
  font-weight: 600 !important;
}

.EditPlanPopup-module__font-w-700___BsRXz {
  font-weight: 700 !important;
}

.EditPlanPopup-module__p-5___sSc9l {
  padding: 5px !important;
}

.EditPlanPopup-module__p-12___bmChN {
  padding: 12px !important;
}

.EditPlanPopup-module__p-16___dugxJ {
  padding: 16px !important;
}

.EditPlanPopup-module__p-30___CsaPm {
  padding: 30px !important;
}

.EditPlanPopup-module__p-b-0___m6cnA {
  padding-bottom: 0 !important;
}

.EditPlanPopup-module__p-b-5___inhYW {
  padding-bottom: 5px !important;
}

.EditPlanPopup-module__p-b-10___tpRHR {
  padding-bottom: 10px !important;
}

.EditPlanPopup-module__p-b-12___KiOZA {
  padding-bottom: 12px !important;
}

.EditPlanPopup-module__p-b-16___bygx4 {
  padding-bottom: 16px !important;
}

.EditPlanPopup-module__p-b-18___sfbdp {
  padding-bottom: 18px !important;
}

.EditPlanPopup-module__p-b-20___w_hBE {
  padding-bottom: 20px !important;
}

.EditPlanPopup-module__p-b-25___O7HXH {
  padding-bottom: 25px !important;
}

.EditPlanPopup-module__p-b-30___cuV7O {
  padding-bottom: 30px !important;
}

.EditPlanPopup-module__p-b-50___nJQCR {
  padding-bottom: 50px !important;
}

.EditPlanPopup-module__p-t-0___muJF4 {
  padding-top: 0 !important;
}

.EditPlanPopup-module__p-t-12___gJSz2 {
  padding-top: 12px !important;
}

.EditPlanPopup-module__p-t-16___J57px {
  padding-top: 16px !important;
}

.EditPlanPopup-module__p-t-18___H_XxM {
  padding-top: 18px !important;
}

.EditPlanPopup-module__p-t-20___Zxe3v {
  padding-top: 20px !important;
}

.EditPlanPopup-module__p-t-30____0zw2 {
  padding-top: 30px !important;
}

.EditPlanPopup-module__p-t-40___k7_yb {
  padding-top: 40px !important;
}

.EditPlanPopup-module__p-t-50___g_j5K {
  padding-top: 50px !important;
}

.EditPlanPopup-module__p-l-20___fTqZg {
  padding-left: 20px !important;
}

.EditPlanPopup-module__p-l-30___t1DUH {
  padding-left: 30px !important;
}

.EditPlanPopup-module__p-l-40___SS9xw {
  padding-left: 40px !important;
}

.EditPlanPopup-module__p-r-16___kNygb {
  padding-right: 16px !important;
}

.EditPlanPopup-module__p-r-20___brOmh {
  padding-right: 20px !important;
}

.EditPlanPopup-module__p-r-30___aPG_3 {
  padding-right: 30px !important;
}

.EditPlanPopup-module__p-r-50___yPduV {
  padding-right: 50px !important;
}

.EditPlanPopup-module__p-r-60___qTPaW {
  padding-right: 60px !important;
}

.EditPlanPopup-module__m-b-1___aPk7M {
  margin-bottom: 1px !important;
}

.EditPlanPopup-module__m-b-2___bmLk7 {
  margin-bottom: 2px !important;
}

.EditPlanPopup-module__m-b-6___MXt8v {
  margin-bottom: 6px !important;
}

.EditPlanPopup-module__m-b-8___YlEUz {
  margin-bottom: 8px !important;
}

.EditPlanPopup-module__m-b-10___rKWkB {
  margin-bottom: 10px !important;
}

.EditPlanPopup-module__m-b-14____m1fP {
  margin-bottom: 14px !important;
}

.EditPlanPopup-module__m-b-16___BCMMQ {
  margin-bottom: 16px !important;
}

.EditPlanPopup-module__m-b-20___fP6EA {
  margin-bottom: 20px !important;
}

.EditPlanPopup-module__m-b-22___wgyVV {
  margin-bottom: 22px !important;
}

.EditPlanPopup-module__m-b-24___BFW1E {
  margin-bottom: 24px !important;
}

.EditPlanPopup-module__m-b-30___XbF3w {
  margin-bottom: 30px !important;
}

.EditPlanPopup-module__m-b-32___WfHaw {
  margin-bottom: 32px !important;
}

.EditPlanPopup-module__m-b-40___NHBF3 {
  margin-bottom: 40px !important;
}

.EditPlanPopup-module__m-t-2___Kc2Is {
  margin-top: 2px !important;
}

.EditPlanPopup-module__m-t-3___CPq_h {
  margin-top: 3px !important;
}

.EditPlanPopup-module__m-t-4___Cs4k6 {
  margin-top: 4px !important;
}

.EditPlanPopup-module__m-t-5___t87xg {
  margin-top: 5px !important;
}

.EditPlanPopup-module__m-t-8___xnbRJ {
  margin-top: 8px !important;
}

.EditPlanPopup-module__m-t-10___rRCIa {
  margin-top: 10px !important;
}

.EditPlanPopup-module__m-t-15___BJ7im {
  margin-top: 15px !important;
}

.EditPlanPopup-module__m-t-16___MvGpe {
  margin-top: 16px !important;
}

.EditPlanPopup-module__m-t-20___OeQK3 {
  margin-top: 20px !important;
}

.EditPlanPopup-module__m-t-22___qR83I {
  margin-top: 22px !important;
}

.EditPlanPopup-module__m-t-30___cZc_B {
  margin-top: 30px !important;
}

.EditPlanPopup-module__m-t-32___OwCzk {
  margin-top: 32px !important;
}

.EditPlanPopup-module__m-l-auto___qCZ_t {
  margin-left: auto !important;
}

.EditPlanPopup-module__m-l-4___NtA3I {
  margin-left: 4px !important;
}

.EditPlanPopup-module__m-l-5___VEPSu {
  margin-left: 5px !important;
}

.EditPlanPopup-module__m-l-6___VvNXX {
  margin-left: 6px !important;
}

.EditPlanPopup-module__m-l-8___A3Zae {
  margin-left: 8px !important;
}

.EditPlanPopup-module__m-l-10___sNYkW {
  margin-left: 10px !important;
}

.EditPlanPopup-module__m-l-16___ov9V2 {
  margin-left: 16px !important;
}

.EditPlanPopup-module__m-l-20___mGxqD {
  margin-left: 20px !important;
}

.EditPlanPopup-module__m-l-24___HCWEY {
  margin-left: 24px !important;
}

.EditPlanPopup-module__m-l-30___Vw4pE {
  margin-left: 30px !important;
}

.EditPlanPopup-module__m-l-35___FvWl5 {
  margin-left: 35px !important;
}

.EditPlanPopup-module__m-l-40___BPI0J {
  margin-left: 40px !important;
}

.EditPlanPopup-module__m-r-8___cbGuh {
  margin-right: 8px !important;
}

.EditPlanPopup-module__m-r-10___GySpL {
  margin-right: 10px !important;
}

.EditPlanPopup-module__m-r-16___PBaXc {
  margin-right: 16px !important;
}

.EditPlanPopup-module__m-r-20___etyg_ {
  margin-right: 20px !important;
}

.EditPlanPopup-module__m-r-24___ZPOyt {
  margin-right: 24px !important;
}

.EditPlanPopup-module__m-r-30___wxtF9 {
  margin-right: 30px !important;
}

.EditPlanPopup-module__m-r-40___JosMI {
  margin-right: 40px !important;
}

.EditPlanPopup-module__border-r-3___snD_b {
  border-radius: 3px !important;
}

.EditPlanPopup-module__border-r-4___CqLwQ {
  border-radius: 4px !important;
}

.EditPlanPopup-module__border-r-6___F1qlL {
  border-radius: 6px !important;
}

.EditPlanPopup-module__border-r-10___aDNQ8 {
  border-radius: 10px !important;
}

.EditPlanPopup-module__border-r-12___Ur6DU {
  border-radius: 12px !important;
}

.EditPlanPopup-module__border-r-16___NUW25 {
  border-radius: 16px !important;
}

.EditPlanPopup-module__border-r-50___uq0Ck {
  border-radius: 50% !important;
}

.EditPlanPopup-module__primary-border___wIxdo {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.EditPlanPopup-module__primary-border-b___zZsSI {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.EditPlanPopup-module__primary-border-t___s67yZ {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.EditPlanPopup-module__primary-border-l___jki21 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.EditPlanPopup-module__primary-border-r___Z7Ctw {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.EditPlanPopup-module__secondary-border___L2cMI {
  border: 1px solid #637768;
}

.EditPlanPopup-module__secondary-border-b___BHoTe {
  border-bottom: 1px solid #637768;
}

.EditPlanPopup-module__secondary-border-t___vdNL6 {
  border-top: 1px solid #637768;
}

.EditPlanPopup-module__secondary-border-l___hafAr {
  border-left: 1px solid #637768;
}

.EditPlanPopup-module__secondary-border-r___PmCWF {
  border-right: 1px solid #637768;
}

.EditPlanPopup-module__gap-0___qh2rs {
  gap: 0 !important;
}

.EditPlanPopup-module__gap-2___fN2Po {
  gap: 2px !important;
}

.EditPlanPopup-module__gap-4___Ogc7t {
  gap: 4px !important;
}

.EditPlanPopup-module__gap-5___UHJqo {
  gap: 5px !important;
}

.EditPlanPopup-module__gap-6___sZgxl {
  gap: 6px !important;
}

.EditPlanPopup-module__gap-8___jPTmc {
  gap: 8px !important;
}

.EditPlanPopup-module__gap-10___f7vZr {
  gap: 10px !important;
}

.EditPlanPopup-module__gap-12___JdTge {
  gap: 12px !important;
}

.EditPlanPopup-module__gap-14___uiS6x {
  gap: 14px !important;
}

.EditPlanPopup-module__gap-16___MVwyC {
  gap: 16px !important;
}

.EditPlanPopup-module__gap-18___r6VkE {
  gap: 18px !important;
}

.EditPlanPopup-module__gap-20___b8d2z {
  gap: 20px !important;
}

.EditPlanPopup-module__gap-24___e0GrA {
  gap: 24px !important;
}

.EditPlanPopup-module__gap-26___jixbG {
  gap: 26px !important;
}

.EditPlanPopup-module__gap-30___ZcHcs {
  gap: 30px !important;
}

.EditPlanPopup-module__gap-32___Bu0a5 {
  gap: 32px !important;
}

.EditPlanPopup-module__gap-40___hzntM {
  gap: 40px !important;
}

.EditPlanPopup-module__gap-50___EKowX {
  gap: 50px !important;
}

.EditPlanPopup-module__flex-1___zLBLf {
  flex: 1;
}

.EditPlanPopup-module__flex-none___hfCCX {
  flex: none !important;
}

.EditPlanPopup-module__flex-column___eh5_E {
  display: flex;
  flex-direction: column !important;
}

.EditPlanPopup-module__flex-row___bnk__ {
  display: flex;
  flex-direction: row !important;
}

.EditPlanPopup-module__vertically-centered___uGwqn {
  display: flex;
  align-items: center !important;
}

.EditPlanPopup-module__horizontally-centered___Bu2HV {
  display: flex;
  justify-content: center !important;
}

.EditPlanPopup-module__horizontally-end___Zt0gJ {
  display: flex;
  justify-content: end !important;
}

.EditPlanPopup-module__vertically-start___GZSzt {
  display: flex;
  align-items: start !important;
}

.EditPlanPopup-module__space-between___Qu32Y {
  display: flex;
  justify-content: space-between !important;
}

.EditPlanPopup-module__flex-wrap___mkbfa {
  flex-wrap: wrap !important;
}

.EditPlanPopup-module__height-100___i0zwY {
  height: 100%;
}

.EditPlanPopup-module__width-50___mTP5s {
  width: 50% !important;
}

.EditPlanPopup-module__width-100___h620E {
  width: 100%;
}

.EditPlanPopup-module__cursor-pointer___bDX2K {
  cursor: pointer;
}

.EditPlanPopup-module__cursor-not-allowed___crjj2 {
  cursor: not-allowed !important;
}

.EditPlanPopup-module__absolute-centered___PpDOz {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.EditPlanPopup-module__absolute___pxDjk {
  position: absolute;
}

.EditPlanPopup-module__relative___xMFnX {
  position: relative;
}

.EditPlanPopup-module__fixed___zETw4 {
  position: fixed;
}

.EditPlanPopup-module__visible___ZTrDt {
  opacity: 1;
}

.EditPlanPopup-module__invisible___FqHJX {
  opacity: 0;
}

.EditPlanPopup-module__col-90___TqOSl {
  width: 90% !important;
}

.EditPlanPopup-module__col-auto___N9Ofd {
  width: auto !important;
}

.EditPlanPopup-module__medical-tabs___j6h6T {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.EditPlanPopup-module__medical-table-new___Mw1cA {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.EditPlanPopup-module__medical-table-new___Mw1cA:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.EditPlanPopup-module__medical-table-new___Mw1cA::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.EditPlanPopup-module__medical-table-new___Mw1cA::-webkit-scrollbar-track {
  display: none;
}
.EditPlanPopup-module__medical-table-new___Mw1cA.EditPlanPopup-module__no-pagination___cn3Y2 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.EditPlanPopup-module__medical-table-new___Mw1cA.EditPlanPopup-module__no-pagination___cn3Y2:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.EditPlanPopup-module__medical-table-new___Mw1cA.EditPlanPopup-module__no-pagination___cn3Y2::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.EditPlanPopup-module__medical-table-new___Mw1cA.EditPlanPopup-module__no-pagination___cn3Y2::-webkit-scrollbar-track {
  display: none;
}

.EditPlanPopup-module__medical-table-empty___hHBrO {
  padding: 14px 40px !important;
}

.EditPlanPopup-module__icon-btn___JLq_6 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.EditPlanPopup-module__search-icon___QuYEx {
  width: 24px;
  height: 24px;
  align-self: center;
}

.EditPlanPopup-module__disable-select___zQDnH {
  user-select: none;
}

.EditPlanPopup-module__break-word___tzM_4 {
  word-break: break-word;
}

.EditPlanPopup-module__popup-clear-btn___NqoCR {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.EditPlanPopup-module__scroll-m-b-20___DNNoY {
  scroll-margin-bottom: 20px;
}

.EditPlanPopup-module__wrapper___O8r4W {
  padding: 25px 30px;
  display: grid;
  column-gap: 30px;
  row-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
}
.EditPlanPopup-module__wrapper___O8r4W .EditPlanPopup-module__width75___Z_vg3 {
  grid-column: 2 span;
}
.EditPlanPopup-module__wrapper___O8r4W .EditPlanPopup-module__option___jMCgJ {
  color: #375844;
}

.EditPlanPopup-module__buttonsContainer___ix0_1 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
  justify-content: end;
  padding: 30px;
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/EditPlanPopup/EditPlanPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,qCAAA;AA8pBF;AA5pBE;EACE,mBAAA;AA8pBJ;AA3pBE;EACE,cAAA;AA6pBJ;;AAzpBA;EACE,2CAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AA4pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.wrapper {\n  padding: 25px 30px;\n  display: grid;\n  column-gap: 30px;\n  row-gap: 25px;\n  grid-template-columns: repeat(3, 1fr);\n\n  .width75 {\n    grid-column: 2 span;\n  }\n\n  .option {\n    color: get-color(greenNew, dark);\n  }\n}\n\n.buttonsContainer {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n  justify-content: end;\n  padding: 30px;\n  display: flex;\n  gap: 16px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `EditPlanPopup-module__font-s-10___CJlmW`,
	"fontS12": `EditPlanPopup-module__font-s-12___HQng8`,
	"fontS13": `EditPlanPopup-module__font-s-13___uGwIz`,
	"fontS14": `EditPlanPopup-module__font-s-14___LrBA1`,
	"fontS15": `EditPlanPopup-module__font-s-15___cx8HE`,
	"fontS16": `EditPlanPopup-module__font-s-16___RRA7z`,
	"fontS18": `EditPlanPopup-module__font-s-18___h7sCD`,
	"fontS20": `EditPlanPopup-module__font-s-20___gTZQs`,
	"fontS22": `EditPlanPopup-module__font-s-22___JSVIT`,
	"fontS28": `EditPlanPopup-module__font-s-28___GNCil`,
	"fontW400": `EditPlanPopup-module__font-w-400___PsrkX`,
	"fontW500": `EditPlanPopup-module__font-w-500___b8a0x`,
	"fontW600": `EditPlanPopup-module__font-w-600___blWhw`,
	"fontW700": `EditPlanPopup-module__font-w-700___BsRXz`,
	"p5": `EditPlanPopup-module__p-5___sSc9l`,
	"p12": `EditPlanPopup-module__p-12___bmChN`,
	"p16": `EditPlanPopup-module__p-16___dugxJ`,
	"p30": `EditPlanPopup-module__p-30___CsaPm`,
	"pB0": `EditPlanPopup-module__p-b-0___m6cnA`,
	"pB5": `EditPlanPopup-module__p-b-5___inhYW`,
	"pB10": `EditPlanPopup-module__p-b-10___tpRHR`,
	"pB12": `EditPlanPopup-module__p-b-12___KiOZA`,
	"pB16": `EditPlanPopup-module__p-b-16___bygx4`,
	"pB18": `EditPlanPopup-module__p-b-18___sfbdp`,
	"pB20": `EditPlanPopup-module__p-b-20___w_hBE`,
	"pB25": `EditPlanPopup-module__p-b-25___O7HXH`,
	"pB30": `EditPlanPopup-module__p-b-30___cuV7O`,
	"pB50": `EditPlanPopup-module__p-b-50___nJQCR`,
	"pT0": `EditPlanPopup-module__p-t-0___muJF4`,
	"pT12": `EditPlanPopup-module__p-t-12___gJSz2`,
	"pT16": `EditPlanPopup-module__p-t-16___J57px`,
	"pT18": `EditPlanPopup-module__p-t-18___H_XxM`,
	"pT20": `EditPlanPopup-module__p-t-20___Zxe3v`,
	"pT30": `EditPlanPopup-module__p-t-30____0zw2`,
	"pT40": `EditPlanPopup-module__p-t-40___k7_yb`,
	"pT50": `EditPlanPopup-module__p-t-50___g_j5K`,
	"pL20": `EditPlanPopup-module__p-l-20___fTqZg`,
	"pL30": `EditPlanPopup-module__p-l-30___t1DUH`,
	"pL40": `EditPlanPopup-module__p-l-40___SS9xw`,
	"pR16": `EditPlanPopup-module__p-r-16___kNygb`,
	"pR20": `EditPlanPopup-module__p-r-20___brOmh`,
	"pR30": `EditPlanPopup-module__p-r-30___aPG_3`,
	"pR50": `EditPlanPopup-module__p-r-50___yPduV`,
	"pR60": `EditPlanPopup-module__p-r-60___qTPaW`,
	"mB1": `EditPlanPopup-module__m-b-1___aPk7M`,
	"mB2": `EditPlanPopup-module__m-b-2___bmLk7`,
	"mB6": `EditPlanPopup-module__m-b-6___MXt8v`,
	"mB8": `EditPlanPopup-module__m-b-8___YlEUz`,
	"mB10": `EditPlanPopup-module__m-b-10___rKWkB`,
	"mB14": `EditPlanPopup-module__m-b-14____m1fP`,
	"mB16": `EditPlanPopup-module__m-b-16___BCMMQ`,
	"mB20": `EditPlanPopup-module__m-b-20___fP6EA`,
	"mB22": `EditPlanPopup-module__m-b-22___wgyVV`,
	"mB24": `EditPlanPopup-module__m-b-24___BFW1E`,
	"mB30": `EditPlanPopup-module__m-b-30___XbF3w`,
	"mB32": `EditPlanPopup-module__m-b-32___WfHaw`,
	"mB40": `EditPlanPopup-module__m-b-40___NHBF3`,
	"mT2": `EditPlanPopup-module__m-t-2___Kc2Is`,
	"mT3": `EditPlanPopup-module__m-t-3___CPq_h`,
	"mT4": `EditPlanPopup-module__m-t-4___Cs4k6`,
	"mT5": `EditPlanPopup-module__m-t-5___t87xg`,
	"mT8": `EditPlanPopup-module__m-t-8___xnbRJ`,
	"mT10": `EditPlanPopup-module__m-t-10___rRCIa`,
	"mT15": `EditPlanPopup-module__m-t-15___BJ7im`,
	"mT16": `EditPlanPopup-module__m-t-16___MvGpe`,
	"mT20": `EditPlanPopup-module__m-t-20___OeQK3`,
	"mT22": `EditPlanPopup-module__m-t-22___qR83I`,
	"mT30": `EditPlanPopup-module__m-t-30___cZc_B`,
	"mT32": `EditPlanPopup-module__m-t-32___OwCzk`,
	"mLAuto": `EditPlanPopup-module__m-l-auto___qCZ_t`,
	"mL4": `EditPlanPopup-module__m-l-4___NtA3I`,
	"mL5": `EditPlanPopup-module__m-l-5___VEPSu`,
	"mL6": `EditPlanPopup-module__m-l-6___VvNXX`,
	"mL8": `EditPlanPopup-module__m-l-8___A3Zae`,
	"mL10": `EditPlanPopup-module__m-l-10___sNYkW`,
	"mL16": `EditPlanPopup-module__m-l-16___ov9V2`,
	"mL20": `EditPlanPopup-module__m-l-20___mGxqD`,
	"mL24": `EditPlanPopup-module__m-l-24___HCWEY`,
	"mL30": `EditPlanPopup-module__m-l-30___Vw4pE`,
	"mL35": `EditPlanPopup-module__m-l-35___FvWl5`,
	"mL40": `EditPlanPopup-module__m-l-40___BPI0J`,
	"mR8": `EditPlanPopup-module__m-r-8___cbGuh`,
	"mR10": `EditPlanPopup-module__m-r-10___GySpL`,
	"mR16": `EditPlanPopup-module__m-r-16___PBaXc`,
	"mR20": `EditPlanPopup-module__m-r-20___etyg_`,
	"mR24": `EditPlanPopup-module__m-r-24___ZPOyt`,
	"mR30": `EditPlanPopup-module__m-r-30___wxtF9`,
	"mR40": `EditPlanPopup-module__m-r-40___JosMI`,
	"borderR3": `EditPlanPopup-module__border-r-3___snD_b`,
	"borderR4": `EditPlanPopup-module__border-r-4___CqLwQ`,
	"borderR6": `EditPlanPopup-module__border-r-6___F1qlL`,
	"borderR10": `EditPlanPopup-module__border-r-10___aDNQ8`,
	"borderR12": `EditPlanPopup-module__border-r-12___Ur6DU`,
	"borderR16": `EditPlanPopup-module__border-r-16___NUW25`,
	"borderR50": `EditPlanPopup-module__border-r-50___uq0Ck`,
	"primaryBorder": `EditPlanPopup-module__primary-border___wIxdo`,
	"primaryBorderB": `EditPlanPopup-module__primary-border-b___zZsSI`,
	"primaryBorderT": `EditPlanPopup-module__primary-border-t___s67yZ`,
	"primaryBorderL": `EditPlanPopup-module__primary-border-l___jki21`,
	"primaryBorderR": `EditPlanPopup-module__primary-border-r___Z7Ctw`,
	"secondaryBorder": `EditPlanPopup-module__secondary-border___L2cMI`,
	"secondaryBorderB": `EditPlanPopup-module__secondary-border-b___BHoTe`,
	"secondaryBorderT": `EditPlanPopup-module__secondary-border-t___vdNL6`,
	"secondaryBorderL": `EditPlanPopup-module__secondary-border-l___hafAr`,
	"secondaryBorderR": `EditPlanPopup-module__secondary-border-r___PmCWF`,
	"gap0": `EditPlanPopup-module__gap-0___qh2rs`,
	"gap2": `EditPlanPopup-module__gap-2___fN2Po`,
	"gap4": `EditPlanPopup-module__gap-4___Ogc7t`,
	"gap5": `EditPlanPopup-module__gap-5___UHJqo`,
	"gap6": `EditPlanPopup-module__gap-6___sZgxl`,
	"gap8": `EditPlanPopup-module__gap-8___jPTmc`,
	"gap10": `EditPlanPopup-module__gap-10___f7vZr`,
	"gap12": `EditPlanPopup-module__gap-12___JdTge`,
	"gap14": `EditPlanPopup-module__gap-14___uiS6x`,
	"gap16": `EditPlanPopup-module__gap-16___MVwyC`,
	"gap18": `EditPlanPopup-module__gap-18___r6VkE`,
	"gap20": `EditPlanPopup-module__gap-20___b8d2z`,
	"gap24": `EditPlanPopup-module__gap-24___e0GrA`,
	"gap26": `EditPlanPopup-module__gap-26___jixbG`,
	"gap30": `EditPlanPopup-module__gap-30___ZcHcs`,
	"gap32": `EditPlanPopup-module__gap-32___Bu0a5`,
	"gap40": `EditPlanPopup-module__gap-40___hzntM`,
	"gap50": `EditPlanPopup-module__gap-50___EKowX`,
	"flex1": `EditPlanPopup-module__flex-1___zLBLf`,
	"flexNone": `EditPlanPopup-module__flex-none___hfCCX`,
	"flexColumn": `EditPlanPopup-module__flex-column___eh5_E`,
	"flexRow": `EditPlanPopup-module__flex-row___bnk__`,
	"verticallyCentered": `EditPlanPopup-module__vertically-centered___uGwqn`,
	"horizontallyCentered": `EditPlanPopup-module__horizontally-centered___Bu2HV`,
	"horizontallyEnd": `EditPlanPopup-module__horizontally-end___Zt0gJ`,
	"verticallyStart": `EditPlanPopup-module__vertically-start___GZSzt`,
	"spaceBetween": `EditPlanPopup-module__space-between___Qu32Y`,
	"flexWrap": `EditPlanPopup-module__flex-wrap___mkbfa`,
	"height100": `EditPlanPopup-module__height-100___i0zwY`,
	"width50": `EditPlanPopup-module__width-50___mTP5s`,
	"width100": `EditPlanPopup-module__width-100___h620E`,
	"cursorPointer": `EditPlanPopup-module__cursor-pointer___bDX2K`,
	"cursorNotAllowed": `EditPlanPopup-module__cursor-not-allowed___crjj2`,
	"absoluteCentered": `EditPlanPopup-module__absolute-centered___PpDOz`,
	"absolute": `EditPlanPopup-module__absolute___pxDjk`,
	"relative": `EditPlanPopup-module__relative___xMFnX`,
	"fixed": `EditPlanPopup-module__fixed___zETw4`,
	"visible": `EditPlanPopup-module__visible___ZTrDt`,
	"invisible": `EditPlanPopup-module__invisible___FqHJX`,
	"col90": `EditPlanPopup-module__col-90___TqOSl`,
	"colAuto": `EditPlanPopup-module__col-auto___N9Ofd`,
	"medicalTabs": `EditPlanPopup-module__medical-tabs___j6h6T`,
	"medicalTableNew": `EditPlanPopup-module__medical-table-new___Mw1cA`,
	"noPagination": `EditPlanPopup-module__no-pagination___cn3Y2`,
	"medicalTableEmpty": `EditPlanPopup-module__medical-table-empty___hHBrO`,
	"iconBtn": `EditPlanPopup-module__icon-btn___JLq_6`,
	"searchIcon": `EditPlanPopup-module__search-icon___QuYEx`,
	"disableSelect": `EditPlanPopup-module__disable-select___zQDnH`,
	"breakWord": `EditPlanPopup-module__break-word___tzM_4`,
	"popupClearBtn": `EditPlanPopup-module__popup-clear-btn___NqoCR`,
	"scrollMB20": `EditPlanPopup-module__scroll-m-b-20___DNNoY`,
	"wrapper": `EditPlanPopup-module__wrapper___O8r4W`,
	"width75": `EditPlanPopup-module__width75___Z_vg3`,
	"option": `EditPlanPopup-module__option___jMCgJ`,
	"buttonsContainer": `EditPlanPopup-module__buttonsContainer___ix0_1`
};
module.exports = ___CSS_LOADER_EXPORT___;
